module.exports = __webpack_public_path__ + "static/media/web_image.4686b77f.jpg";